import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import { readableNumberParts } from '../../../helpers/Numbers';
const PaymentTableRow = ({ payment }) => {
    return (_jsxs(TableRow, { noHover: true, children: [_jsx(TableCell, { label: "Datum", value: new Date(payment.date).toLocaleDateString('nl-nl', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                }) }), _jsx(TableCell, { label: "Bedrag", value: readableNumberParts(payment.amount, 'EUR').long }), _jsx(TableCell, { label: "Omschrijving", value: payment.description })] }));
};
export default PaymentTableRow;
